import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Lock } from 'lucide-react';
import { contactInfoService } from '../services/api';

const emptyContact = {
  email: '',
  phone: '',
  address: '',
};

function Footer() {
  const [contact, setContact] = useState(emptyContact);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const response = await contactInfoService.get();
        if (response.data) {
          setContact({
            email: response.data.email || '',
            phone: response.data.phone || '',
            address: response.data.address || '',
          });
        }
      } catch (error) {
        console.error('Error fetching contact info for footer:', error);
      }
    };
    fetchContact();
  }, []);

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="font-bold text-white mb-4">درباره نشریه</h3>
            <ul className="space-y-2 text-blue-100 text-sm">
              <li><Link to="/about" className="hover:text-white transition">درباره ما</Link></li>
              <li><Link to="/editorial-board" className="hover:text-white transition">هیئت تحریریه</Link></li>
              <li><Link to="/policies" className="hover:text-white transition">سیاست‌های نشریه</Link></li>
              <li><Link to="/history" className="hover:text-white transition">تاریخچه</Link></li>
            </ul>
          </div>

          {/* For Authors */}
          <div>
            <h3 className="font-bold text-white mb-4">برای نویسندگان</h3>
            <ul className="space-y-2 text-blue-100 text-sm">
              <li><Link to="/author-guide" className="hover:text-white transition">راهنمای نویسندگان</Link></li>
              <li><Link to="/submission-process" className="hover:text-white transition">نحوه ارسال</Link></li>
              <li><Link to="/templates" className="hover:text-white transition">قالب‌ها</Link></li>
              <li><Link to="/ethics-review" className="hover:text-white transition">استانداردهای اخلاقی</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-bold text-white mb-4">منابع</h3>
            <ul className="space-y-2 text-blue-100 text-sm">
              <li><Link to="/faq" className="hover:text-white transition">سوالات متداول</Link></li>
              <li><Link to="/archive" className="hover:text-white transition">آرشیو</Link></li>
              <li><Link to="/open-access" className="hover:text-white transition">دسترسی آزاد</Link></li>
              <li><Link to="/sitemap" className="hover:text-white transition">نقشه سایت</Link></li>
            </ul>
          </div>

          {/* Contact & Admin */}
          <div>
            <h3 className="font-bold text-white mb-4">تماس</h3>
            <ul className="space-y-3 text-blue-100 text-sm">
              <li className="flex items-center gap-2">
                <Mail size={16} />
                {contact.email}
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} />
                {contact.phone}
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={16} />
                {contact.address}
              </li>
              <li className="pt-2 border-t border-blue-400">
                <Link to="/admin-login" className="flex items-center gap-2 hover:text-white transition">
                  <Lock size={16} />
                  ورود ادمین
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; 2024 نشریه مجری - سازمان مجری ساختمانها و تأسیسات دولتی و عمومی. تمام حقوق محفوظ است.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
